export const CONTRACT_AGREEMENT = 'contract/agreement/'
export const CONTRACT_AGREEMENT_ALL = `${CONTRACT_AGREEMENT}all`
export const CONTRACT_AGREEMENT_CURRENT = `${CONTRACT_AGREEMENT}get`
export const CONTRACT_AGREEMENT_ACCEPT = `${CONTRACT_AGREEMENT}accept`
export const CONTRACT_AGREEMENT_OPEN = `${CONTRACT_AGREEMENT}open`
export const CONTRACT_DOWNLOAD = `${CONTRACT_AGREEMENT}download`
